import React from "react";

import AdminNav from "../../components/seller-store/admin-layout/nav";
import AdminHeader from "../../components/seller-store/admin-layout/header";
import AdminFooter from "../../components/seller-store/admin-layout/footer";

import "../../adminAssets/css/style.css";
import "../../adminAssets/css/style-preset.css";

{/* <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
<script src="../assets/js/plugins/bootstrap.min.js"></script> 
<script src="../assets/js/plugins/popper.min.js"></script>

<script src="../assets/js/plugins/popper.min.js"></script>
<script src="../assets/js/plugins/simplebar.min.js"></script>
<script src="../assets/js/plugins/bootstrap.min.js"></script>
<script src="../assets/js/fonts/custom-font.js"></script>
<script src="../assets/js/pcoded.js"></script>
<script src="../assets/js/plugins/feather.min.js"></script>

*/}




const AdminProductList = () => {


//     useEffect(() => {
    
//         loadScript("/adminAssets/js/plugins/popper.min.js");
//          loadScript("/adminAssets/js/plugins/simplebar.min.js");
//          loadScript("/adminAssets/js/plugins/bootstrap.min.js");
//          loadScript("/adminAssets/js/plugins/custom-font.min.js");
//          loadScript("/adminAssets/js/plugins/pcoded.min.js");
//          loadScript("/adminAssets/js/plugins/feather.min.js");
      
//   }, []);

// useEffect(() => {
//     loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js")
//       .then(() =>
//         loadScript("/adminAssets/js/plugins/bootstrap.min.js")
//       );
//   }, []);


  return (
    <>

    <AdminNav />
        
    <AdminHeader />
   
    <div class="pc-container">
        <div class="pc-content">
           {/* render body here */}
        </div>
    </div>


    <AdminFooter />
    
    </>
  );
};

export default AdminProductList;